import cn from "classnames"

type Props = {
  className?: string,
  color?: 'black' | 'white',
  count?: number,
}

const DotsPulse = ({
  className = "",
  color = 'black',
  count = 3,
}: Props) => {
  return (
    <div className={cn('dot-pulse-wrap', className)}>
      {[...Array(count)].map((_, index) => (
        <span className={`dot-pulse bg-${color}`} key={index} />
      ))}
    </div>
  )
}

export default DotsPulse
